import { noop } from '@chillibean/component-library';

import { Role } from '../../models';
import { getRoles } from '../../services';
import * as actionTypes from './types';

export const setRoles = (value) => {
  return {
    type: actionTypes.SET_ROLES,
    value: value,
  };
};

export const fetchRoles =
  ({ onError = noop, onSuccess = noop } = {}) =>
  async (dispatch, getState) => {
    const { account, authenticityToken } = getState().internalReducer.internal;

    dispatch(setRoles({ data: [], error: false, loading: true }));
    try {
      const data = await getRoles({ accountId: account?.id, authenticityToken: authenticityToken });

      dispatch(setRoles({ data: data.map((role) => new Role(role)), error: false, loading: false }));
      onSuccess();
    } catch (err) {
      dispatch(setRoles({ data: [], error: err, loading: false }));
      onError(err);
    }
  };

export default setRoles;
